import React, { useState } from 'react';
import Icon from '../AppIcon';
import Input from './Input';
import Select from './Select';
import Button from './Button';

const SearchFilterBar = ({
  searchValue = '',
  onSearchChange,
  filters = [],
  onFilterChange,
  onClearFilters,
  placeholder = 'Search...',
  showAdvancedFilters = false,
  onToggleAdvanced,
  className = ''
}) => {
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const handleToggleAdvanced = () => {
    const newState = !isAdvancedOpen;
    setIsAdvancedOpen(newState);
    if (onToggleAdvanced) {
      onToggleAdvanced(newState);
    }
  };

  const hasActiveFilters = filters?.some(filter => 
    filter?.value && filter?.value !== '' && filter?.value !== filter?.defaultValue
  );

  const handleClearAll = () => {
    if (onClearFilters) {
      onClearFilters();
    }
  };

  return (
    <div className={`bg-surface border border-border rounded-lg p-4 space-y-4 ${className}`}>
      {/* Main Search Bar */}
      <div className="flex items-center space-x-3">
        <div className="flex-1 relative">
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Icon name="Search" size={16} className="text-text-secondary" />
          </div>
          <Input
            type="search"
            placeholder={placeholder}
            value={searchValue}
            onChange={(e) => onSearchChange && onSearchChange(e?.target?.value)}
            className="pl-10"
          />
        </div>

        {/* Filter Toggle */}
        {showAdvancedFilters && (
          <Button
            variant={isAdvancedOpen ? "default" : "outline"}
            size="default"
            iconName="Filter"
            iconPosition="left"
            onClick={handleToggleAdvanced}
          >
            Filters
            {hasActiveFilters && (
              <span className="ml-1 px-1.5 py-0.5 bg-primary text-primary-foreground text-xs rounded-full">
                {filters?.filter(f => f?.value && f?.value !== '' && f?.value !== f?.defaultValue)?.length}
              </span>
            )}
          </Button>
        )}

        {/* Clear Filters */}
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="default"
            iconName="X"
            iconPosition="left"
            onClick={handleClearAll}
            className="text-text-secondary hover:text-text-primary"
          >
            Clear
          </Button>
        )}
      </div>
      {/* Advanced Filters */}
      {showAdvancedFilters && isAdvancedOpen && (
        <div className="border-t border-border pt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filters?.map((filter) => (
              <div key={filter?.key}>
                {filter?.type === 'select' ? (
                  <Select
                    label={filter?.label}
                    placeholder={filter?.placeholder}
                    options={filter?.options}
                    value={filter?.value}
                    onChange={(value) => onFilterChange && onFilterChange(filter?.key, value)}
                    clearable
                  />
                ) : filter?.type === 'date' ? (
                  <Input
                    type="date"
                    label={filter?.label}
                    value={filter?.value}
                    onChange={(e) => onFilterChange && onFilterChange(filter?.key, e?.target?.value)}
                  />
                ) : filter?.type === 'daterange' ? (
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-text-primary">{filter?.label}</label>
                    <div className="grid grid-cols-2 gap-2">
                      <Input
                        type="date"
                        placeholder="From"
                        value={filter?.value?.from || ''}
                        onChange={(e) => onFilterChange && onFilterChange(filter?.key, {
                          ...filter?.value,
                          from: e?.target?.value
                        })}
                      />
                      <Input
                        type="date"
                        placeholder="To"
                        value={filter?.value?.to || ''}
                        onChange={(e) => onFilterChange && onFilterChange(filter?.key, {
                          ...filter?.value,
                          to: e?.target?.value
                        })}
                      />
                    </div>
                  </div>
                ) : (
                  <Input
                    type={filter?.type || 'text'}
                    label={filter?.label}
                    placeholder={filter?.placeholder}
                    value={filter?.value}
                    onChange={(e) => onFilterChange && onFilterChange(filter?.key, e?.target?.value)}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchFilterBar;